import * as React from 'react'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Chip from '@mui/material/Chip'
import Button from '@mui/material/Button'

import useToggle from '~/client/hooks/useToggle'
import Timestamp from '~/client/components/Timestamp'
import Avatar from '~/client/components/Avatar'
import AppIcon from '~/client/components/AppIcon'
import CurrentUserAvatar from '~/client/components/CurrentUserAvatar'
import InspectObject from '~/client/components/InspectObject'

export default function HistoryList({ loading, error, events = [] }) {
  return (
    <TableContainer sx={{maxWidth: '75vw'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Triggered By</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Occurred At</TableCell>
            <TableCell>Detail</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
          {loading
            ? <TableRow>
              <TableCell colSpan={4}>
                Loading…
              </TableCell>
            </TableRow>
            : events.map(event =>
              <HistoryTableRow key={event.id} event={event}/>
            )
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}

function HistoryTableRow({ event }){
  const [showingData, , , toggleShowingData] = useToggle()
  return <>
    <TableRow>
      <TableCell sx={{p: 1}}>
        {event.appAccountId
          ? <>Third Party</>
          : <>Self</>
        }
      </TableCell>
      <TableCell sx={{p: 1}}>
        <Chip label={event.label} />
      </TableCell>
      <TableCell sx={{p: 1}}>
        <Timestamp at={event.createdAt} sx={{whiteSpace: 'nowrap'}}/>
      </TableCell>
      <TableCell sx={{p: 1, overflow: 'scroll'}}>
        <Button variant="text" onClick={toggleShowingData}>
          {showingData ? `Hide` : `Show`} Details
        </Button>
      </TableCell>
    </TableRow>
    {showingData
      ? <TableRow>
        <TableCell colSpan={4} sx={{m:0, p: 0}}>
          <InspectObject object={massageData(event)} sx={{m:0, p:1}}/>
        </TableCell>
      </TableRow>
      : null
    }
  </>
}
function massageData(event){
  const data = {...event.data}
  for (const prop of ['userId', 'appId'])
    if (!(prop in event.data) && event[prop])
      data[prop] = event[prop]
  return data
}
